import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "uv-tile-form-row uv-tile-form-row-cb" }
const _hoisted_2 = ["id", "name", "value", "checked"]
const _hoisted_3 = ["for", "innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "uv-enquiry-error-message"
}

import { computed } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    label: null,
    value: { type: [String, Number, Boolean] },
    checked: { type: Boolean },
    modelValue: { type: [String, Number, Boolean] },
    error: null
  },
  emits: ['change', 'update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
		name: string,
		label: string,
		value: string | number | boolean, 
		checked?: boolean, 
		modelValue?: string | number | boolean, 
		error?: string
	}

	

	

	const isChecked = computed((): boolean => {
		return props.checked || (props.modelValue == "0" ? false : !!props.modelValue);
	});

	const handleChange = (): void => {
		emit('change');
	}
	const handleInput = ($event: Event): void => {
		const isNum = typeof props.modelValue == 'number';
		const isString = typeof props.modelValue == 'string';
		const isChecked = ($event.target as HTMLInputElement).checked;
		let emitVal: any = isChecked;
		if (isNum){
			emitVal = isChecked ? 1 : 0;
		}
		else if (isString){
			emitVal = isChecked ? "1" : "0";	
		}
		console.log('emitVal', emitVal);
		emit('update:modelValue', emitVal);
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      id: `uv-input-name-${props.name}`,
      name: props.name,
      value: props.value,
      checked: _unref(isChecked),
      onChange: handleChange,
      onInput: handleInput
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: `uv-input-name-${__props.name}`,
      innerHTML: props.label
    }, null, 8, _hoisted_3),
    (props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})